import { Document } from '@contentful/rich-text-types';

export const isDocument = (document: unknown): document is Document =>
  typeof (document as Document)?.content === 'object' &&
  typeof (document as Document)?.data === 'object' &&
  typeof (document as Document)?.nodeType === 'string';
